import dayjs from 'dayjs';

export const getTimezone = () => {
  const date = new Date();
  const hoursOffset = date.getTimezoneOffset() / 60; // eastern regions than UTC have negative offset

  return `GMT${hoursOffset <= 0 ? '+' : '-'}${Math.abs(hoursOffset)}`;
};

export const isPast = (date, unit = 'second') => dayjs().isAfter(date, unit);
